<template>
    <section class="voices-quote" :style="quoteStyle" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay">
        <div class="voices-quote__content">
            <h2 class="voices-quote__title">{{ sectionTitle }}</h2>
            <blockquote class="voices-quote__text">"{{ currentSlide.text }}"</blockquote>
            <p class="voices-quote__author">— {{ currentSlide.author }}</p>
            <div class="voices-quote__dots">
                <button v-for="(slide, index) in slides" :key="slide.id" class="voices-quote__dot"
                    :class="{ 'voices-quote__dot--active': index === currentIndex }" type="button"
                    @click="setSlide(index)" :aria-label="`Go to quote ${index + 1}`"></button>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'HomeVoicesQuote',
    data() {
        return {
            currentIndex: 0,
            timer: null
        };
    },
    computed: {
        ...mapGetters(['livableCityData']),
        sectionTitle() {
            return 'Voices of the Greats'
        },
        slides() {
            const list = this.livableCityData.quotes || []
            if (list.length <= 3) {
                return list
            }
            const seed = (this.$route.path || '/').split('').reduce((sum, ch) => sum + ch.charCodeAt(0), 0)
            const start = seed % list.length
            return [list[start], list[(start + 1) % list.length], list[(start + 2) % list.length]]
        },
        currentSlide() {
            return this.slides[this.currentIndex] || this.slides[0];
        },
        quoteStyle() {
            return {
                backgroundImage: `url(${this.currentSlide.image})`
            };
        }
    },
    mounted() {
        this.startAutoPlay();
    },
    beforeDestroy() {
        this.stopAutoPlay();
    },
    methods: {
        startAutoPlay() {
            this.stopAutoPlay();
            if (this.slides.length < 2) {
                return;
            }
            this.timer = setInterval(() => {
                this.nextSlide();
            }, 5000);
        },
        stopAutoPlay() {
            if (!this.timer) {
                return;
            }
            clearInterval(this.timer);
            this.timer = null;
        },
        nextSlide() {
            this.currentIndex = (this.currentIndex + 1) % this.slides.length;
        },
        setSlide(index) {
            this.currentIndex = index;
            this.startAutoPlay();
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.voices-quote {
    position: relative;
    width: 100%;
    height: rem(520);
    box-sizing: border-box;
    background-size: cover;
    background-position: center;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.3);
    }

    &__content {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        color: #fff;
        gap: rem(24);
    }

    &__title {
        margin: 0;
        font-family: $font-family-serif;
        font-size: rem(36);
        font-weight: 700;
        line-height: rem(44);
        text-shadow: 0 rem(2) rem(4) rgba(0, 0, 0, 0.16);
    }

    &__text {
        margin: 0;
        font-family: $font-family-serif;
        font-size: rem(20);
        font-style: italic;
        font-weight: 400;
        line-height: rem(32);
        text-shadow: 0 rem(2) rem(4) rgba(0, 0, 0, 0.16);
    }

    &__author {
        margin: 0;
        font-family: $font-family-serif;
        font-size: rem(18);
        font-style: italic;
        font-weight: 700;
        line-height: rem(24);
        text-shadow: 0 rem(2) rem(4) rgba(0, 0, 0, 0.16);
    }

    &__dots {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: rem(16);
        position: relative;
        padding: rem(40) 0;
        z-index: 1;
    }

    &__dot {
        width: rem(8);
        height: rem(8);
        border: 0;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.3);
        flex-shrink: 0;
        padding: 0;
        cursor: pointer;

        &--active {
            background: #fff;
        }
    }

}

.detect_deviece_pc,
.detect_deviece_desktop {
    .voices-quote {
        &__content {
            height: 100%;
            padding: rem(120) rem(440) 0;
        }
    }
}

.detect_deviece_mobile {
    .voices-quote {
        &__content {
            height: 100%;
            padding: rem(80) rem(16) 0;
        }
    }
}
</style>
